import { useTranslation } from 'react-i18next';
import { Card } from 'reactstrap';
import { Button } from '@octano/global-ui';

import { TranslationsKeys } from '../../../locales/translations';
import AuthorizationDataLoader, {
  AuthorizationTableContainer,
} from './parts/AuthorizationDataLoader';
import AuthorizationFilterLoader from './parts/AuthorizationFilterLoader';
import AuthorizationSearchBar from './parts/AuthorizationSearchBar';
import AuthorizationTable from './parts/AuthorizationTable';

export default function AuthorizationRequestsList() {
  const { t } = useTranslation(TranslationsKeys.HOMOLOGATION_AUTHORIZATION);

  return (
    <div className="mx-3">
      <Card className="p-4">
        <AuthorizationFilterLoader>
          <p className="mb-4 text-muted">{t('description')}</p>
          <AuthorizationDataLoader>
            <AuthorizationSearchBar />
            <div className="d-flex justify-content-end mb-3">
              <Button
                text={t('downloadList')}
                size="sm"
                outlined
                onClick={() => {
                  // TODO: implement download endpoint
                }}
              />
            </div>
            <AuthorizationTableContainer>
              <AuthorizationTable />
            </AuthorizationTableContainer>
          </AuthorizationDataLoader>
        </AuthorizationFilterLoader>
      </Card>
    </div>
  );
}
